var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { ShadowlessElement, WithDisposable } from '@blocksuite/lit';
import { html } from 'lit';
import { customElement, property, query } from 'lit/decorators.js';
import { toast } from '../../../_common/components/toast.js';
import { CloseIcon } from '../../../_common/icons/index.js';
import { bookmarkModalStyles } from './styles.js';
let BookmarkCreateModal = class BookmarkCreateModal extends WithDisposable(ShadowlessElement) {
    constructor() {
        super(...arguments);
        this._onDocumentKeydown = (e) => {
            e.stopPropagation();
            if (e.key === 'Enter' && !e.isComposing) {
                this._onConfirm();
            }
            if (e.key === 'Escape') {
                this.remove();
            }
        };
        this._onConfirm = () => {
            const url = this.input.value;
            if (url.length === 0) {
                toast('Bookmark url can not be empty');
                return;
            }
            this.onConfirm?.(url);
            this.remove();
        };
        this._onCancel = () => {
            this.onCancel?.();
            this.remove();
        };
    }
    connectedCallback() {
        super.connectedCallback();
        this.updateComplete
            .then(() => {
            requestAnimationFrame(() => {
                this.input.focus();
            });
        })
            .catch(console.error);
        this.disposables.addFromEvent(this, 'keydown', this._onDocumentKeydown);
    }
    render() {
        return html `<div class="bookmark-modal">
      <div class="bookmark-modal-mask" @click=${this._onCancel}></div>
      <div class="bookmark-modal-wrapper" style="width:480px">
        <icon-button
          width="32px"
          height="32px"
          class="bookmark-modal-close-button"
          @click=${this._onCancel}
          >${CloseIcon}</icon-button
        >

        <div class="bookmark-modal-title">Bookmark</div>
        <div class="bookmark-modal-desc">
          Create a Bookmark that previews a link in card view.
        </div>
        <input
          tabindex="1"
          type="text"
          class="bookmark-modal-input link"
          placeholder="Input in https://..."
        />

        <div class="bookmark-modal-footer">
          <div
            tabindex="2"
            class="bookmark-modal-confirm-button"
            @click=${this._onConfirm}
          >
            Confirm
          </div>
        </div>
      </div>
    </div>`;
    }
};
BookmarkCreateModal.styles = bookmarkModalStyles;
__decorate([
    property({ attribute: false })
], BookmarkCreateModal.prototype, "onCancel", void 0);
__decorate([
    property({ attribute: false })
], BookmarkCreateModal.prototype, "onConfirm", void 0);
__decorate([
    query('input')
], BookmarkCreateModal.prototype, "input", void 0);
BookmarkCreateModal = __decorate([
    customElement('bookmark-create-modal')
], BookmarkCreateModal);
export { BookmarkCreateModal };
export async function toggleBookmarkCreateModal(host) {
    host.selection.clear();
    const bookmarkCreateModal = new BookmarkCreateModal();
    return new Promise(resolve => {
        bookmarkCreateModal.onConfirm = url => {
            resolve(url);
        };
        bookmarkCreateModal.onCancel = () => {
            resolve(null);
        };
        document.body.appendChild(bookmarkCreateModal);
    });
}
//# sourceMappingURL=bookmark-create-modal.js.map